export const getNavLinkBehavior = menuNode => {
  const link = menuNode?.link;
  const isExternalRoute = Boolean(menuNode?.isExternalRoute || /^https?:\/\//i.test(String(link || '')));
  const openInNewTab = Boolean(menuNode?.openInNewTab);

  return {
    link,
    isExternalRoute,
    target: openInNewTab ? '_blank' : undefined,
    rel: openInNewTab ? 'noopener noreferrer' : undefined,
  };
};
